import { render, staticRenderFns } from "./PosInvoiceReceipt.vue?vue&type=template&id=f01d66d6&scoped=true&"
import script from "./PosInvoiceReceipt.vue?vue&type=script&lang=js&"
export * from "./PosInvoiceReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01d66d6",
  null
  
)

export default component.exports